import { mapState, mapGetters } from 'vuex';
import { ProgressFooterToolbar } from 'ipro-ui-kit-vuejs/src/components';
import { AccessRequestService } from '@/core/access-request';
import { WorkerOnBoardingRoutesMixin } from '@/portal/worker-on-boarding/mixins';

// @vue/component
export default {
  components: {
    ProgressFooterToolbar,
  },
  mixins: [
    WorkerOnBoardingRoutesMixin,
  ],
  computed: {
    ...mapState('workerOnBoarding', ['selectedBusiness']),
    ...mapGetters('workerOnBoarding', {
      businessName: 'selectedBusinessName',
    }),
  },
  methods: {
    async requestAccess() {
      try {
        if (this.selectedBusiness.uuid) {
          await AccessRequestService.create(this.selectedBusiness.uuid);
          this.$router.push(this.routes.accessRequestSent);
        }
      } catch (error) {
        // do nothing
      }
    },
  },
};
